import { type Component, Index } from 'solid-js'

import { Field, Select, Text, createListCollection } from '@components'
import { type PositionEnum, directionList } from '@here/api'
import { ChevronDownIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { LastSelectDisabled } from './LastSelectDisabled'

export const Position: Component = () => {
	const { filters, setPosition } = useService(useFilters)()

	const collection = createListCollection({ items: directionList })

	const selected = () => filters().position

	return (
		<Field.Root>
			<Field.Label>Position</Field.Label>
			<Select.Root
				positioning={{
					sameWidth: true,
				}}
				multiple
				value={selected()}
				collection={collection}
				onValueChange={({ value }) => {
					setPosition(value as PositionEnum[])
				}}
			>
				<Select.Control>
					<Select.Trigger>
						<Select.ValueText />
						<Select.Indicator>
							<ChevronDownIcon />
						</Select.Indicator>
					</Select.Trigger>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						<Select.ItemGroup>
							<Index each={collection.items}>
								{(item) => (
									<LastSelectDisabled
										item={item()}
										selected={selected()}
									/>
								)}
							</Index>
						</Select.ItemGroup>
					</Select.Content>
				</Select.Positioner>
				<Select.HiddenSelect />
			</Select.Root>
		</Field.Root>
	)
}
